module.exports = __webpack_public_path__ + "static/img/01.c1c9471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Products/ProductList/images/01.jpg
// module id = f+nt
// module chunks = 1